import { useObservable } from "@faire/web--source/ui/hooks/useObservable";
/**
 * Creates a comparer that returns true if all `keys` in objects `a` and `b` are the same value.
 */ export var newStoreResultComparer = function(keys) {
    return function(a, b) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (!Object.is(a[key], b[key])) {
                    return false;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return true;
    };
};
/** Store hook factory
 * @param store - store that we want a hook for
 * @returns - hook that observes changes to the store state
 */ export var createStoreHook = function(Store) {
    return function(fields) {
        return useObservable(function() {
            var store = Store.get();
            var partialStore = {};
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var field = _step.value;
                    partialStore[field] = store[field];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return partialStore;
        }, fields, newStoreResultComparer(fields));
    };
};
